<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em">Gregory lives in Virginia with his wife, Carinthia.</p><br/>
<p style="text-indent:0em">He is a retired executive with AT&amp;T.</p><br/>
<p style="text-indent:0em">He has a love of music and sports.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?28c5e9ba